// import { appConfig } from './app/app.config';
import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { createAppConfig } from './app/app.config';
import 'leaflet'; // Load leaflet before everything else
import 'proj4leaflet'; // extend Leaflet (L) with projection-info
import 'leaflet-wms-header'; // extend leaflet (L) with wms-header-extension

// Load config.json before booting up so info for MSAL is availlable
fetch('./assets/config.json')
  .then((resp) => resp.json())
  .then((config) => {
    bootstrapApplication(AppComponent, createAppConfig(config));
  });
